const EDGE_WIDTH = 12;

/**
 * Scale edge indicator width to maintain visual balance as blocks shrink
 * Fixed-width edges would look disproportionately thick on smaller screens
 * where blocks are scaled down, making the UI feel heavy and cluttered
 */
export const getResponsiveEdgeWidth = (): number => {
	const width = window.innerWidth;

	if (width < 768) {
		// Mobile: 50% scale -> 6px
		return EDGE_WIDTH * 0.5;
	} else if (width < 1024) {
		// Small Tablet: 60% scale -> 7px
		return EDGE_WIDTH * 0.6;
	} else if (width < 1366) {
		// Large Tablet: 70% scale -> 8px
		return EDGE_WIDTH * 0.7;
	}

	// Desktop: 100% scale -> 12px
	return EDGE_WIDTH;
};

export default EDGE_WIDTH;
